import type {
  Template,
  GetTemplatesRequestBody,
  UpdateTemplateRequestBody,
} from "@/common/types/templates";
import { getCustomTemplates } from "@/services/templates";
import { create } from "zustand";

export interface TemplateState {
  templates: Template[];
  loading: boolean;
  error: boolean;

  getTemplates: () => Template[];
  updateTemplateById: (template: UpdateTemplateRequestBody) => void;
  fetchAndSetTemplates: (body: GetTemplatesRequestBody) => Promise<void>;
}

export const useTemplateStore = create<TemplateState>()((set, get) => ({
  templates: [],
  loading: false,
  error: false,

  getTemplates: (): Template[] => get().templates,

  updateTemplateById: (editTemplate: UpdateTemplateRequestBody): void => {
    const storeTemplates = get().templates;
    const templatesIndex = storeTemplates.findIndex(
      (template: Template) => editTemplate.id === template.id
    );
    if (templatesIndex !== -1) {
      storeTemplates[templatesIndex] = {
        ...editTemplate,
        ...storeTemplates[templatesIndex],
      } as Template;
      set({ templates: storeTemplates, loading: false, error: false });
    } else {
      set({ loading: false, error: false });
    }
  },

  fetchAndSetTemplates: async (
    body: GetTemplatesRequestBody
  ): Promise<void> => {
    set({ loading: true, error: false });

    try {
      const templates = await getCustomTemplates(body);

      set({ templates, loading: false });
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_) {
      set({ templates: [], loading: false, error: true });
    }
  },
}));
